export default __webpack_public_path__ + "static/media/dropdown.ae7e89eb.svg";